/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-26 23:00:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchContentPromotion } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/redux';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import style from '../style.module.less';

const CloneBtn = ({ buttonText, disabled }: any) => {
  const params: any = useParams();
  const { contentUuid } = params;
  const _d = useDispatch();
  const handleOnClick = () => {
    _d(
      fetchContentPromotion({
        //1===true 0===false
        uuid: contentUuid,
        params: {
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
        },
        isClone: true,
      }),
    );
  };
  return (
    <Button
      onClick={handleOnClick}
      buttonText={buttonText}
      disabled={disabled}
      className={style.cloneBtnWidth}
    />
  );
};
export default CloneBtn;
